const Loader = ({ theme }) => (
    <div className={`${theme.background} ${theme.textNormal} min-h-screen flex items-center justify-center`}>
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-brand-500"></div>
    </div>
);

export default Loader;
